<template>
  <div class="swiper-slide">
    <div class="slide-text">
      <p class="slide-text-title">{{ item.title }}</p>
      <p class="slide-text-content">{{ item.text }}</p>
      <span>查看更多&gt;&gt;</span>
    </div>
    <img class="slide-img" :src="item.src" alt="" />
    <div class="slide-img-bottom">{{ item.title }}</div>
  </div>
</template>
<script>
export default {
  props: ["item"],
};
</script>
<style>
.swiper-slide {
  width: 25%;
  position: relative;
}
.slide-text {
  position: absolute;
  top: -100%;
  left: 0;
  height: 100%;
  width: 100%;
}
.slide-text {
  background-color: #3367cf;
  opacity: 0.8;
  color: #ffffff;
}
.slide-text-title {
  font-size: 14px;
  margin-top: 90px;
  margin-bottom: 20px;
  text-align: center;
}
.slide-text-content {
  font-size: 10px;
  line-height: 16px;
  padding: 10px;
}
.slide-text > span {
  position: absolute;
  right: 10px;
  bottom: 20px;
  cursor: pointer;
  font-size: 10px;
}
.swiper-slide:hover > .slide-text {
  transition: top 0.5s;
  top: 0;
}
.swiper-slide:hover > .slide-img-bottom {
  display: none;
}
.slide-img {
  width: 100%;
}
.slide-img-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 36px;
  color: #ffffff;
  font-size: 12px;
  background-color: #333333;
  opacity: 0.5;
  text-align: center;
  line-height: 36px;
}
</style>


// WEBPACK FOOTER //
// src/components/product/imgItem.vue